module.exports = __webpack_public_path__ + "img/ico_certificate_list.a0851988.svg";